import { render, staticRenderFns } from "./ContactLink.vue?vue&type=template&id=73ab67c9&scoped=true&"
import script from "./ContactLink.vue?vue&type=script&lang=ts&"
export * from "./ContactLink.vue?vue&type=script&lang=ts&"
import style0 from "./ContactLink.vue?vue&type=style&index=0&id=73ab67c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab67c9",
  null
  
)

export default component.exports